import axios from "../api/axios";

export const getBenefits = async (token: string) => {
  const res = await axios.get("benefits", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};